import { getDimensionError, isPositiveNumber, type SizeConstraints } from "@/lib/product/customSizeValidation";

export function truncateToThreeDecimals(value: string): string {
  const dotIndex = value.indexOf(".");
  if (dotIndex === -1) return value;
  return value.slice(0, dotIndex + 4);
}

export function getCurrentDimensionError(
  width: string,
  height: string,
  constraints: SizeConstraints,
): string | undefined {
  if (!width || !height) return undefined;
  if (!isPositiveNumber(width) || !isPositiveNumber(height)) return "Please enter valid dimensions";
  return getDimensionError(
    Number(truncateToThreeDecimals(width)),
    Number(truncateToThreeDecimals(height)),
    constraints,
  );
}

interface AppliedCheck {
  localWidth: string;
  localHeight: string;
  storeWidth: string | undefined;
  storeHeight: string | undefined;
}

export function isDimensionApplied({ localWidth, localHeight, storeWidth, storeHeight }: AppliedCheck): boolean {
  return Boolean(localWidth && localHeight && localWidth === storeWidth && localHeight === storeHeight);
}

interface DisplayErrorArgs {
  showErrors: boolean;
  localWidth: string;
  localHeight: string;
  storeWidth: string | undefined;
  storeHeight: string | undefined;
  constraints: SizeConstraints;
  storeSizeError: string | undefined;
}

interface DisplayErrorResult {
  displayError: string | undefined;
  isApplied: boolean;
}

export function resolveDisplayError({
  showErrors,
  localWidth,
  localHeight,
  storeWidth,
  storeHeight,
  constraints,
  storeSizeError,
}: DisplayErrorArgs): DisplayErrorResult {
  const localError = showErrors ? getCurrentDimensionError(localWidth, localHeight, constraints) : undefined;
  const isApplied = isDimensionApplied({ localWidth, localHeight, storeWidth, storeHeight }) && !localError;
  const fallback = isApplied ? undefined : storeSizeError;
  return { displayError: localError ?? fallback, isApplied };
}
